import { Suspense, type ReactNode } from "react";
import { LoadingState } from "@/shared/ui";

export function LazyPage({ children }: { children: ReactNode }) {
  return <Suspense fallback={<LoadingState />}>{children}</Suspense>;
}
